import React, {Component} from 'react';
import {connect} from 'react-redux';
import {message, Button, Icon} from 'antd';
import {NavLink} from 'react-router-dom';

import Contractor from './Contractor';
import {
    storeContractor,
    updateLandlordContractor,
    fetchContractors
} from '../../../actions';

class ContractorContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverErrors: null
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {contractor} = nextProps;
        if (!contractor) return null;

        if (contractor.error) {
            return {serverErrors: contractor.error}
        }
        if (!contractor.error && prevState.serverErrors) {
            return {serverErrors: null}
        }
        return null;
    }
    static notifySuccess() {
        message.success('Successfully updated');
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}, props: {history}} = this;
        if (!serverErrors) {
            ContractorContainer.notifySuccess();
            setTimeout(() => history.goBack(), 100);
            return;
        }

        const {res: {errors, message}} = serverErrors;
        ContractorContainer.notifyError(errors || message);
    }
    componentDidMount() {
        const {
            match: {params: {contractor: id}},
            landlord,
            fetchContractors,
            contractor
        } = this.props;

        if (!id) return;
        !contractor && fetchContractors(landlord);
    }
    render() {
        const {storeContractor, updateLandlordContractor, landlord, history, contractor} = this.props;
        const onSubmit = (values) => {
            const fn = !contractor || contractor.draft ? storeContractor : updateLandlordContractor;
            const args = !contractor || contractor.draft ? [landlord, values] : [landlord, contractor.id, {...values, id: contractor.id}];
            return fn(...args).then(() => this.handlePostSubmit(values));
        };

        let extra = null;
        if (contractor && !contractor.draft) {
            extra = (
                <NavLink to={`/provider/contractors/${contractor.id}/properties`}>
                    <Button><Icon type="home"/> Assigned Properties</Button>
                </NavLink>
            )
        }
        return <Contractor contractor={contractor} onSubmit={onSubmit} onCancel={() => history.goBack()} extra={extra}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    // id exists for edit component
    const {match: {params: {contractor: id}}} = ownProps;
    const contractor = state.landlord.contractors.data.find(b => id ? (b.id === +id) : b.draft);
    return {
        landlord: state.me.application.id,
        contractor
    };
};
export default connect(mapStateToProps, {
    storeContractor,
    updateLandlordContractor,
    fetchContractors
})(ContractorContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/contractor/ContractorContainer.js